// Authenticated app-shell strings for GetPaid: header, user menu, sign-out,
// wizard primitives, and the passkey-setup dialog. Nav labels live in
// common.nav.* (common.en.ts). EN is the source of truth — every key here has
// a pt-BR counterpart in shell.pt-BR.ts.
const shell: Record<string, string> = {
  // Header / user menu
  'shell.userMenu.open': 'Account menu',
  'shell.userMenu.addPasskey': 'Add a passkey',
  'shell.userMenu.signOut': 'Sign out',
  'shell.signOut.confirm': 'Sign out of GetPaid?',

  // Wizard shared primitives (Stepper / CopyableField)
  'shell.wizard.copy': 'Copy',
  'shell.wizard.copied': 'Copied',

  // Passkey-setup dialog
  'shell.passkey.title': 'Passkeys',
  'shell.passkey.description':
    'Sign in faster next time with your device — fingerprint, face, or screen lock. No password to remember.',
  'shell.passkey.add': 'Add a passkey',
  'shell.passkey.adding': 'Setting up…',
  'shell.passkey.added': 'Passkey added.',
  'shell.passkey.namePlaceholder': 'This device',
  'shell.passkey.nameLabel': 'Name (optional)',
  'shell.passkey.listTitle': 'Your passkeys',
  'shell.passkey.empty': 'You have no passkeys yet.',
  'shell.passkey.loading': 'Loading passkeys…',
  'shell.passkey.loadError': 'Could not load your passkeys. Try again.',
  'shell.passkey.delete': 'Remove',
  'shell.passkey.deleting': 'Removing…',
  'shell.passkey.deleted': 'Passkey removed.',
  'shell.passkey.deleteConfirm': 'Remove this passkey?',
  'shell.passkey.unnamed': 'Unnamed passkey',
  'shell.passkey.createdAt': 'Added {date}',
  'shell.passkey.lastUsed': 'Last used {date}',
  'shell.passkey.neverUsed': 'Never used',
  'shell.passkey.unsupported':
    'This device or browser does not support passkeys. Try a different device.',
  'shell.passkey.error': 'Could not set up the passkey. Please try again.',
  'shell.passkey.close': 'Close',
};

export default shell;
